const defaultOptions = {
  closeButton: true,
  progressBar: true,
};

export const showToast = (type, message, options = {}) =>
  Promise.all([
    import(/* webpackChunkName: "toastr" */ 'toastr'),
    import(/* webpackChunkName: "toastr" */ '../../stylesheets/toastr.scss'),
  ]).then(([{ default: toastr }]) => toastr[type](message, '', { ...defaultOptions, ...options }));
